import { ENVIRONMENT } from '../environment/environment.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Environment, Response } from '@viso/core/models';
import { Inject, Injectable } from '@angular/core';
import { MasterService } from '../master/master.service';
import { Feedback } from '@viso/core/models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  constructor(
    private http: HttpClient,
    private masterService: MasterService,
    @Inject(ENVIRONMENT) private environment: Environment
  ) {}

  getVendorFeedback() {
    return this.http.get<Response<Feedback[]>>(
      `${this.environment.API_URL}/vendor/app-suggestions`
    );
  }

  getClientFeedback() {
    return this.http.get<Response<Feedback[]>>(
      `${this.environment.API_URL}/client/app-suggestions`
    );
  }

  addFeedback(request: {name: string, description: string, attachments: any}) {
    return this.http.post<Response<any>>(
      `${this.environment.API_URL}/vendor/app-suggestions`,
      request
    );
  }
}